/* fj-facets.js: small helpers for the cream-pill filters (snippets/facets.liquid).
   Shopify's own facets.js still does all filtering, URL updates and counts. */
(function () {
  if (window.__fjFacets) return; window.__fjFacets = true;

  function fire(input) { input.dispatchEvent(new Event('input', { bubbles: true })); }

  /* price quick chips: fill From/To, then let facets.js submit */
  function preset(chip) {
    var box = chip.closest('.facets__display, .mobile-facets__submenu, .facets__display-vertical');
    var pr = box && box.querySelector('price-range');
    if (!pr) return;
    var ins = pr.querySelectorAll('input'), lo = chip.dataset.min, hi = chip.dataset.max;
    var on = chip.getAttribute('aria-pressed') === 'true';
    box.querySelectorAll('.fj-preset').forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
    if (on) { ins[0].value = ''; ins[1].value = ''; }
    else { ins[0].value = lo === '0' ? '' : lo; ins[1].value = hi || ''; chip.setAttribute('aria-pressed', 'true'); }
    ins[1].min = ins[0].value || 0;
    ins[0].max = ins[1].value || ins[1].getAttribute('placeholder') || '';
    fire(ins[1]);
  }
  document.addEventListener('click', function (e) {
    var c = e.target.closest('.fj-preset');
    if (c) { e.preventDefault(); preset(c); }
  });
  document.addEventListener('keydown', function (e) {
    var c = e.target.closest && e.target.closest('.fj-preset');
    if (c && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); preset(c); return; }
    /* Escape closes an open desktop pill panel and returns focus to its pill */
    if (e.key === 'Escape') {
      var d = e.target.closest && e.target.closest('details.facets__disclosure[open]');
      if (d) { e.preventDefault(); d.removeAttribute('open'); var s = d.querySelector('summary'); s && s.focus(); }
    }
  });

  /* keep aria-expanded right on desktop pills (incl. sort) */
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d.classList || !d.classList.contains('facets__disclosure')) return;
    var s = d.querySelector('summary'); s && s.setAttribute('aria-expanded', d.open ? 'true' : 'false');
    if (d.open) {
      /* one pill open at a time */
      document.querySelectorAll('details.facets__disclosure[open]').forEach(function (o) { if (o !== d) o.removeAttribute('open'); });
    }
  }, true);

  /* sort: close the panel once a choice is made (mouse/touch) */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.name === 'sort_by' && t.type === 'radio') {
      var d = t.closest('details.fj-sort');
      if (d && e.detail !== 0) setTimeout(function () { d.removeAttribute('open'); }, 160);
      var v = d && d.querySelector('[data-fj-val]'); if (v) v.textContent = t.nextElementSibling.textContent;
    }
  });

  /* live "current selection" text on pills / sheet rows */
  function txt(lbl) {
    var sp = lbl.querySelector('.facet-checkbox__text');
    return sp ? (sp.firstChild ? sp.firstChild.textContent : sp.textContent).trim() : lbl.textContent.trim();
  }
  function money(n) { return '$' + Number(n).toLocaleString('en-US', { maximumFractionDigits: 0 }); }
  function sync(f) {
    var v = f.querySelector('[data-fj-val]'); if (!v) return;
    var pr = f.querySelector('price-range');
    if (pr) {
      var i = pr.querySelectorAll('input'), a = i[0].value, b = i[1].value;
      v.textContent = (a === '' && b === '') ? 'Any' : money(a || 0) + '–' + money(b || i[1].getAttribute('max') || 0);
      return;
    }
    var ck = [].slice.call(f.querySelectorAll('input[type=checkbox]:checked')).filter(function (x) { return !x.closest('.no-js-list'); });
    v.textContent = ck.length === 0 ? 'All' : ck.length === 1 ? txt(ck[0].closest('label')) : ck.length + ' picked';
  }
  document.addEventListener('input', function (e) {
    var f = e.target.closest && e.target.closest('.js-filter'); if (f) sync(f);
  });
  document.addEventListener('change', function (e) {
    var f = e.target.closest && e.target.closest('.js-filter'); if (f) sync(f);
  });
})();
